import { useEffect, useState } from "react";
import Select from "react-select";
import * as Yup from "yup";
import { FormikProvider, Form, Field, ErrorMessage, useFormik } from "formik";
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { failureAlert, successAlert2 } from "../CommonUtils/SweetAlerts";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { config } from "../CommonUtils/CommonURLS";
function ServiceMapping() {
  // **********hooks********
  const userId = sessionStorage.getItem("user_id");
  const [serviceRoleData, setServiceRoleData] = useState([]);
  const [serviceTableData, setServiceTableData] = useState([]);
  const [serviceId, setServiceId] = useState(null);

  // ******** validation schema********
  const validationSchema = Yup.object({
    targetName: Yup.string().required(ERROR_MSG).nullable(),
    displayName: Yup.string().required(ERROR_MSG).nullable(),
    Priority: Yup.string().required(ERROR_MSG).nullable(),
    role: Yup.array().min(1, ERROR_MSG).required(ERROR_MSG),
  });

  // *******formik*********
  const serviceFormik = useFormik({
    initialValues: {
      targetName: "",
      displayName: "",
      Priority: "",
      role: [],
    },
    validationSchema,
    onSubmit: (val) => {
      // ******** payload ********
      const payload = {
        serviceName: val.targetName,
        displayName: val.displayName,
        orderBy: val.Priority,
        createdBy: userId || "",
        role: val.role,
      };

      if (serviceId != null) {
        payload.serviceId = serviceId;
      }
      Swal.fire({
        text: "Are you sure you want to submit?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes Submit!",
        cancelButtonText: "No, cancel!",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const url = config.url.API_URL + "saveService";
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                successAlert2(res?.data?.sdesc);
                serviceFormik.resetForm();
                GetServiceTableDetails();
              } else {
                failureAlert(res?.data?.sdesc);
              }
            })
            .catch((error) => {
              console.error("API Error:", error);
              failureAlert("An error occurred while submitting the data.");
            });
        }
      });
    },
  });
  // ******** role ----get api*******
  function GetRoleDetails() {
    let url = config.url.API_URL + "roles";
    CommonAxiosGet(url).then((response) => {
      if (response?.data?.status === true) {
        setServiceRoleData(response?.data?.roles);
      } else {
        setServiceRoleData([]);
      }
    });
  }
  // ******** service table ----get api*******
  function GetServiceTableDetails() {
    let url = config.url.API_URL + "rolesservices";
    CommonAxiosGet(url).then((response) => {
      if (response?.data?.status === true) {
        setServiceTableData(response?.data?.data);
        setServiceId(null);
      } else {
        setServiceTableData([]);
      }
    });
  }
  // ******** service table ----delete api*******
  function handleDelete(serviceId) {
    Swal.fire({
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, cancel!",
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        let url = config.url.API_URL + "deleteservice/" + serviceId;
        CommonAxiosPost(url) // no payload
          .then((response) => {
            if (response?.data?.status === true) {
              successAlert2(response?.data?.message || "Deleted successfully");
              GetServiceTableDetails(); // 🔄 refresh table
            } else {
              failureAlert(response?.data?.message || "Delete failed");
            }
          })
          .catch((error) => {
            console.error("Delete API Error:", error);
            failureAlert("An error occurred while deleting");
          });
      }
    });
  }
  // ******** service table ----edit api*******
  const handleEdit = (rowData) => {
    const parsedRoles = rowData.role_ids
      ? String(rowData.role_ids)
        .split(",")
        .map((id) => {
          const numericId = Number(id);
          return isNaN(numericId) ? id : numericId;
        })
      : [];
    serviceFormik.setValues({
      targetName: rowData.service_name,
      displayName: rowData.display_name,
      Priority: rowData.order_by,
      role: parsedRoles,
    });
    // scroll AFTER render
    setTimeout(() => {
      document
        .getElementById("service-form")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  };

  useEffect(() => {
    GetRoleDetails();
    GetServiceTableDetails();
  }, []);

  const roleOptions = serviceRoleData?.map((role) => ({
    label: role.role_name,
    value: role.role_id,
  }));

  const serviceTableColumns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "service_name",
      header: "Service Name",
      accessorKey: "service_name",
    },
    {
      id: "display_name",
      header: "Display Name",
      accessorKey: "display_name",
    },
    {
      id: "role_ids",
      header: "Role",
      accessorKey: "role_ids",
    },
    {
      id: "order_by",
      header: "Priority",
      accessorKey: "order_by",
    },
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => {
        const rowData = row.original;
        return (
          <div className="d-flex justify-content-start gap-2">
            <button
              type="button"
              className="btn btn-sm btn-warning"
              onClick={() => {
                handleEdit(rowData);
                setServiceId(rowData.service_id);
              }}
            >
              Edit
            </button>

            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={() => {
                handleDelete(rowData?.service_id);
              }}
            >
              Delete
            </button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <bie.Container fluid className="px-1">
        <bie.Container className="px-3 mw-100 pb-5">
          <FormikProvider value={serviceFormik}>
            <Form id="service-form">
              <bie.Row className="g-3">
                <bie.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={4}
                  xl={3}
                  xxl={3}
                  className="mb-2"
                >
                  <label className="form-label">Target Name</label>
                  <Field
                    name="targetName"
                    type="text"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="targetName"
                    component="div"
                    className="text-danger"
                  />
                </bie.Col>

                <bie.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={4}
                  xl={3}
                  xxl={3}
                  className="mb-2"
                >
                  <label className="form-label">Display Name</label>
                  <Field
                    name="displayName"
                    type="text"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="displayName"
                    component="div"
                    className="text-danger"
                  />
                </bie.Col>

                <bie.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={4}
                  xl={3}
                  xxl={3}
                  className="mb-2"
                >
                  <label className="form-label">Priority</label>
                  <Field name="Priority" as="select" className="form-control">
                    <option value="">Select Priority</option>
                    {[...Array(10)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="Priority"
                    component="div"
                    className="text-danger"
                  />
                </bie.Col>

                <bie.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={4}
                  xl={3}
                  xxl={3}
                  className="mb-2"
                >
                  <label className="form-label">Role</label>
                  <Select
                    isMulti
                    options={roleOptions}
                    value={roleOptions?.filter((option) =>
                      serviceFormik.values.role?.includes(option.value),
                    )}
                    onChange={(selectedOptions) => {
                      const roleIds = selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : [];
                      serviceFormik.setFieldValue("role", roleIds);
                    }}
                    className="w-100"
                    classNamePrefix="react-select"
                    placeholder="Select Role"
                  />
                  <ErrorMessage
                    name="role"
                    component="div"
                    className="text-danger"
                  />
                </bie.Col>
              </bie.Row>
              <div className="text-end mt-4">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>

              {serviceTableData?.length > 0 && (
                <>
                  <h5 className="mt-0"> Role Service Mapping </h5>
                  <div className="all-table-content">
                    <div className="table-responsive">
                      <CommonReactTable
                        data={serviceTableData}
                        columns={serviceTableColumns}
                        filename="Role Service Mapping Report"
                        headerName="Role Service Mapping Report"
                        showFooter={true}
                      />
                    </div>
                  </div>
                </>
              )}
            </Form>
          </FormikProvider>
        </bie.Container>
      </bie.Container>
    </>
  );
}
export default ServiceMapping;
